import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';
import {
  Button,
  Typography,
  View,
  YStack,
} from '@shinetools/sunshine-universal';

import fadedFlower from 'assets/brand/faded-flower.png';
import SunshineModal from 'components/_core/SunshineModal';

import { modalMinHeight } from '../utils/constant';

export interface ChallengeRequestErrorProps {
  onClose: () => void;
}

const ChallengeRequestError: FC<ChallengeRequestErrorProps> = ({ onClose }) => {
  return (
    <>
      <SunshineModal.Body minHeight={modalMinHeight}>
        <YStack alignItems="center" gap={24} paddingBottom="$space.24">
          <Image
            src={fadedFlower}
            style={{
              marginBottom: 24,
              opacity: 1,
              width: '30%',
            }}
          />

          <Typography.Header>
            <FormattedMessage id="authentication.challenge.error.title" />
          </Typography.Header>
          <Typography.Text>
            <FormattedMessage id="authentication.challenge.error.description" />
          </Typography.Text>
        </YStack>
      </SunshineModal.Body>
      <SunshineModal.Footer flexDirection="row" gap={16}>
        <View marginLeft="75%">
          <Button onPress={onClose}>
            <FormattedMessage id="authentication.finish" />
          </Button>
        </View>
      </SunshineModal.Footer>
    </>
  );
};

export default ChallengeRequestError;
